import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useInRouterContext } from "react-router-dom";
import kurrLogo from "../../ASSETS/ICONS/kdlogo1.png";
import SocialIconsComponent from "../SOCIAL_ICONS";
import "./index.css";

const Footer = () => {
  const inRouter = useInRouterContext();

  // ✅ Safe link wrapper (prevents router crash)
  const SafeLink = ({ to, children, className }) =>
    inRouter ? (
      <Link to={to} className={className}>
        {children}
      </Link>
    ) : (
      <a href={to} className={className}>
        {children}
      </a>
    );

  return (
    <>
      <footer className="footer">
        <Container>
          <Row className="align-items-start">
            {/* ---- Logo ---- */}
            <Col xs={12} md={3} className="footerCol text-center text-md-start">
              <a href="/" aria-label="KUR Diagnostics Home">
                <img src={kurrLogo} className="footerLogo" alt="Kur logo" />
              </a>
            </Col>

            {/* ---- Home ---- */}
            <Col xs={12} md={2} className="footerCol">
              <h5 className="footerColTitle">Home</h5>
              <ul className="footerList">
                <li>
                  <a href="/screening_program" className="footerItemLink">Screening Programs</a>
                </li>
                <li>
                  <a href="/partner_us" className="footerItemLink">Partner with Us</a>
                </li>
                <li>
                  <a href="/about_us" className="footerItemLink">About Us</a>
                </li>
                <li>
                  <a href="/locations" className="footerItemLink">Locations</a>
                </li>
                <li>
                  <a href="/contact" className="footerItemLink">Contact</a>
                </li>
              </ul>
            </Col>

            {/* ---- About ---- */}
          

            {/* ---- Contact ---- */}
            <Col xs={12} md={3} className="footerCol">
              <h5 className="footerColTitle">Contact</h5>
              <ul className="footerList">
              <li className="footerItem">
                    <a
                      href="tel:(866) 300-5380"
                      className="footerItemLink"
                    >
                      (866) 300 5380
                    </a>
                  </li>
                  <li className="footerItem">
                    <a
                      href="mailto:info@kurdiagnostics.com"
                      className="footerItemLink"
                    >
                      info@kurdiagnostics.com
                    </a>
                  </li>
                  <li className="footerItem addressText">
                    2452 Cedar Springs Rd
                    <br />
                    Dallas, Texas 75201
                  </li>
              </ul>
            </Col>

            {/* ---- Social Icons ---- */}
            <Col xs={12} md={2} className="footerCol text-center text-md-end">
              <SocialIconsComponent />
            </Col>
          </Row>
        </Container>
      </footer>

      {/* ---- Copyright ---- */}
      <div className="copyright">
        <p>
          © KUR International 2025 |{" "}
          <a
            href="https://kurr.com/privacy-policy/"
            className="copyrightItemLink"
          >
            Privacy Policy
          </a>{" "}
          |{" "}
          <a href="https://kurr.com/terms/" className="copyrightItemLink">
            Terms & Conditions
          </a>
        </p>
      </div>
    </>
  );
};

export default Footer;
